import { render, staticRenderFns } from "./approve-detail-classover.html?vue&type=template&id=472d37fa&"
import script from "./approve-detail-classover.ts?vue&type=script&lang=ts&"
export * from "./approve-detail-classover.ts?vue&type=script&lang=ts&"
import style0 from "./approve-detail-classover.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports